import React, { useState, useEffect, useRef, useCallback } from 'react';
import zapataLogo from '../assets/zapata-logo.png';

// ── Traducciones ──────────────────────────────────────────────────────────────
const LANGS = {
  es: {
    headerSubtitle:  'Contrato de mantenimiento',
    loading:         'Cargando contrato…',
    errorContact:    'Llámenos al 966 766 306 y le enviamos un enlace nuevo.',
    successTitle:    'Contrato firmado',
    successEmail:    e  => `Le hemos enviado una copia a ${e}.`,
    successReg:      'Su contrato está registrado correctamente.',
    successActive:   'Su servicio de mantenimiento está activo.',
    successCharge:   amt => `El primer cargo de ${amt}€ se realizará el 10 de enero.`,
    successChargeVisita: 'El importe se abonará en la propia visita de mantenimiento anual.',
    successThanks:   'Gracias por confiar en Climatización Zapata.',
    services:        'Servicios incluidos',
    annualPrice:     'Precio anual',
    sepaRef:         'Cargo el 10 de enero de cada año · Ref. SEPA:',
    sepaRefVisita:   'Cobro en la visita de mantenimiento · Ref. contrato:',
    seeConditions:   'Ver condiciones completas del contrato',
    legal1:          'El presente contrato de mantenimiento anual tiene vigencia de 12 meses desde la fecha de firma, renovándose automáticamente salvo comunicación contraria con al menos 30 días de antelación.',
    legal2:          'El titular del contrato autoriza a Climatización Zapata para realizar el cobro anual indicado mediante domiciliación bancaria SEPA. Cualquier devolución o incidencia en el cobro generará la suspensión temporal del contrato.',
    legal2Visita:    'El titular del contrato queda informado de que el importe anual indicado se abonará en efectivo o con tarjeta en el momento de la visita de mantenimiento, contra el correspondiente justificante o factura.',
    legal3:          'Climatización Zapata se compromete a realizar una revisión completa del equipo durante el período de vigencia del contrato, en la fecha acordada con el titular. Para equipos NUOS Ariston, el contrato incluye la extensión de garantía de 3 a 5 años.',
    bankSection:     'Datos bancarios (domiciliación SEPA)',
    contactSection:  'Datos de contacto',
    dniLabel:        'DNI o NIE del titular *',
    dniPlaceholder:  '12345678A',
    dniHint:         'DNI (8 dígitos + letra), NIE o, si eres extranjero, número de pasaporte (4-20 caracteres)',
    dniOk:           '✓ Documento identificado',
    emailLabel:      'Email de contacto *',
    emailHint:       'Introduce un email válido (recibirás avisos de cobro y visita)',
    emailOk:         '✓ Email verificado',
    pEmail:          'Introduce un email válido',
    ibanLabel:       'IBAN *',
    ibanConfLabel:   'Confirmar IBAN *',
    ibanMismatch:    'Los IBAN no coinciden',
    ibanInvalid:     'IBAN no válido — comprueba los dígitos',
    bicLabel:        'BIC/SWIFT',
    bicOptional:     '(opcional)',
    holderLabel:     'Titular de la cuenta',
    holderPh:        'Nombre titular',
    chargeInfo:      amt => `El cargo de ${amt}€ se realizará el 10 de enero de cada año de forma automática.`,
    chargeInfoVisita: 'El cobro se realizará en la propia visita de mantenimiento, no mediante domiciliación bancaria.',
    consentSection:  'Consentimiento',
    consentA:        'He leído y acepto el contrato de mantenimiento y las condiciones del servicio.',
    consentB:        amt => `Autorizo el cargo anual de ${amt}€ mediante domiciliación SEPA el 10 de enero de cada año.`,
    consentC:        'Acepto recibir comunicaciones comerciales e informativas de Climatización Zapata (consejos de mantenimiento, novedades y ofertas). Opcional — puedo darme de baja en cualquier momento.',
    signSection:     'Firma',
    signHint:        'Firme en el recuadro de abajo con su dedo o el ratón.',
    signDone:        '✓ Firma registrada',
    signCanvas:      'Firme con el dedo o el ratón',
    signClear:       'Borrar y repetir',
    submitBtn:       'Firmar y confirmar contrato',
    submitting:      'Procesando…',
    pDni:            'Introduce tu DNI, NIE o pasaporte',
    pIban:           'Introduce un IBAN válido',
    pIbanMatch:      'Los IBAN no coinciden',
    pConsentA:       'Acepta las condiciones del contrato',
    pConsentB:       'Autoriza la domiciliación SEPA',
    pSign:           'Dibuja tu firma en el recuadro',
  },
  en: {
    headerSubtitle:  'Maintenance contract',
    loading:         'Loading contract…',
    errorContact:    'Call us at +34 966 766 306 and we will send you a new link.',
    successTitle:    'Contract signed',
    successEmail:    e  => `We have sent a copy to ${e}.`,
    successReg:      'Your contract has been registered successfully.',
    successActive:   'Your maintenance service is now active.',
    successCharge:   amt => `The first charge of ${amt}€ will be made on January 10th.`,
    successChargeVisita: 'The amount will be paid at the annual maintenance visit itself.',
    successThanks:   'Thank you for choosing Climatización Zapata.',
    services:        'Included services',
    annualPrice:     'Annual price',
    sepaRef:         'Charged on January 10th each year · SEPA ref:',
    sepaRefVisita:   'Charged at the maintenance visit · Contract ref:',
    seeConditions:   'View full contract conditions',
    legal1:          'This annual maintenance contract is valid for 12 months from the date of signing, automatically renewing unless cancelled at least 30 days in advance.',
    legal2:          'The contract holder authorises Climatización Zapata to make the indicated annual charge by SEPA direct debit. Any return or payment incident will result in temporary suspension of the contract.',
    legal2Visita:    'The contract holder is informed that the indicated annual amount will be paid in cash or by card at the time of the maintenance visit, against the corresponding receipt or invoice.',
    legal3:          'Climatización Zapata undertakes to carry out a full inspection of the equipment during the contract period, on a date agreed with the holder. For NUOS Ariston equipment, the contract includes an extension of the guarantee from 3 to 5 years.',
    bankSection:     'Bank details (SEPA direct debit)',
    contactSection:  'Contact details',
    dniLabel:        'DNI / NIE or passport *',
    dniPlaceholder:  '12345678A',
    dniHint:         'Spanish DNI, NIE or foreign passport number (4–20 characters)',
    dniOk:           '✓ Document identified',
    emailLabel:      'Contact email *',
    emailHint:       'Enter a valid email (you will receive charge and visit notifications)',
    emailOk:         '✓ Email verified',
    pEmail:          'Enter a valid email',
    ibanLabel:       'IBAN *',
    ibanConfLabel:   'Confirm IBAN *',
    ibanMismatch:    'IBANs do not match',
    ibanInvalid:     'Invalid IBAN — check the digits',
    bicLabel:        'BIC/SWIFT',
    bicOptional:     '(optional)',
    holderLabel:     'Account holder',
    holderPh:        'Holder name',
    chargeInfo:      amt => `The charge of ${amt}€ will be made automatically on January 10th each year.`,
    chargeInfoVisita: 'Payment will be collected during the maintenance visit itself, not by bank direct debit.',
    consentSection:  'Consent',
    consentA:        'I have read and accept the maintenance contract and service conditions.',
    consentB:        amt => `I authorise the annual charge of ${amt}€ by SEPA direct debit on January 10th each year.`,
    consentC:        'I agree to receive commercial and informational communications from Climatización Zapata (maintenance tips, news and offers). Optional — I can unsubscribe at any time.',
    signSection:     'Signature',
    signHint:        'Sign in the box below with your finger or mouse.',
    signDone:        '✓ Signature recorded',
    signCanvas:      'Sign with your finger or mouse',
    signClear:       'Clear and redo',
    submitBtn:       'Sign and confirm contract',
    submitting:      'Processing…',
    pDni:            'Enter your DNI, NIE or passport number',
    pIban:           'Enter a valid IBAN',
    pIbanMatch:      'IBANs do not match',
    pConsentA:       'Accept the contract conditions',
    pConsentB:       'Authorise the SEPA direct debit',
    pSign:           'Draw your signature in the box',
  },
  fr: {
    headerSubtitle:  'Contrat de maintenance',
    loading:         'Chargement du contrat…',
    errorContact:    'Appelez-nous au +34 966 766 306 et nous vous enverrons un nouveau lien.',
    successTitle:    'Contrat signé',
    successEmail:    e  => `Nous avons envoyé une copie à ${e}.`,
    successReg:      'Votre contrat a été enregistré avec succès.',
    successActive:   'Votre service de maintenance est maintenant actif.',
    successCharge:   amt => `Le premier prélèvement de ${amt}€ sera effectué le 10 janvier.`,
    successChargeVisita: 'Le montant sera réglé lors de la visite de maintenance annuelle elle-même.',
    successThanks:   'Merci de faire confiance à Climatización Zapata.',
    services:        'Services inclus',
    annualPrice:     'Prix annuel',
    sepaRef:         'Prélevé le 10 janvier de chaque année · Réf. SEPA :',
    sepaRefVisita:   'Paiement lors de la visite de maintenance · Réf. contrat :',
    seeConditions:   'Voir les conditions complètes du contrat',
    legal1:          'Le présent contrat de maintenance annuelle est valable 12 mois à compter de la date de signature, renouvelé automatiquement sauf avis contraire au moins 30 jours avant l\'échéance.',
    legal2:          'Le titulaire du contrat autorise Climatización Zapata à effectuer le prélèvement annuel indiqué par domiciliation bancaire SEPA. Tout retour ou incident de paiement entraînera la suspension temporaire du contrat.',
    legal2Visita:    "Le titulaire du contrat est informé que le montant annuel indiqué sera réglé en espèces ou par carte au moment de la visite de maintenance, contre le justificatif ou la facture correspondante.",
    legal3:          'Climatización Zapata s\'engage à effectuer une révision complète de l\'équipement pendant la période de validité du contrat, à la date convenue avec le titulaire. Pour les équipements NUOS Ariston, le contrat inclut l\'extension de garantie de 3 à 5 ans.',
    bankSection:     'Coordonnées bancaires (prélèvement SEPA)',
    contactSection:  'Coordonnées de contact',
    dniLabel:        'DNI, NIE ou passeport *',
    dniPlaceholder:  '12345678A',
    dniHint:         'DNI espagnol, NIE ou numéro de passeport étranger (4–20 caractères)',
    dniOk:           '✓ Document identifié',
    emailLabel:      'Email de contact *',
    emailHint:       'Entrez un email valide (vous recevrez les avis de prélèvement et de visite)',
    emailOk:         '✓ Email vérifié',
    pEmail:          'Saisissez un email valide',
    ibanLabel:       'IBAN *',
    ibanConfLabel:   'Confirmer l\'IBAN *',
    ibanMismatch:    'Les IBAN ne correspondent pas',
    ibanInvalid:     'IBAN invalide — vérifiez les chiffres',
    bicLabel:        'BIC/SWIFT',
    bicOptional:     '(optionnel)',
    holderLabel:     'Titulaire du compte',
    holderPh:        'Nom du titulaire',
    chargeInfo:      amt => `Le prélèvement de ${amt}€ sera effectué automatiquement le 10 janvier de chaque année.`,
    chargeInfoVisita: "Le paiement sera effectué lors de la visite de maintenance elle-même, et non par prélèvement bancaire.",
    consentSection:  'Consentement',
    consentA:        'J\'ai lu et j\'accepte le contrat de maintenance et les conditions du service.',
    consentB:        amt => `J\'autorise le prélèvement annuel de ${amt}€ par domiciliation SEPA le 10 janvier de chaque année.`,
    consentC:        'J\'accepte de recevoir des communications commerciales et informatives de Climatización Zapata (conseils d\'entretien, nouveautés et offres). Facultatif — je peux me désabonner à tout moment.',
    signSection:     'Signature',
    signHint:        'Signez dans le cadre ci-dessous avec votre doigt ou la souris.',
    signDone:        '✓ Signature enregistrée',
    signCanvas:      'Signez avec votre doigt ou la souris',
    signClear:       'Effacer et recommencer',
    submitBtn:       'Signer et confirmer le contrat',
    submitting:      'Traitement en cours…',
    pDni:            'Entrez votre DNI, NIE ou numéro de passeport',
    pIban:           'Entrez un IBAN valide',
    pIbanMatch:      'Les IBAN ne correspondent pas',
    pConsentA:       'Acceptez les conditions du contrat',
    pConsentB:       'Autorisez le prélèvement SEPA',
    pSign:           'Dessinez votre signature dans le cadre',
  },
};

function detectLang() {
  const l = (navigator.language || 'es').slice(0, 2).toLowerCase();
  return LANGS[l] ? l : 'es';
}

// ── IBAN helpers ──────────────────────────────────────────────────────────────
function validarIBAN(iban) {
  const clean = iban.replace(/\s/g, '').toUpperCase();
  if (clean.length < 15 || clean.length > 34) return false;
  if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]+$/.test(clean)) return false;
  const rearranged = clean.slice(4) + clean.slice(0, 4);
  const numeric    = [...rearranged].map(c => /[A-Z]/.test(c) ? String(c.charCodeAt(0) - 55) : c).join('');
  let rem = 0;
  for (const ch of numeric) rem = (rem * 10 + parseInt(ch, 10)) % 97;
  return rem === 1;
}

const BANCOS = {
  '0001': 'Banco Santander', '0049': 'Banco Santander', '0075': 'Banco Popular',
  '0081': 'Banco Sabadell',  '0128': 'Bankinter',       '0182': 'BBVA',
  '2038': 'Bankia / CaixaBank', '2100': 'CaixaBank',    '3025': 'Caja Rural del Sur',
  '1465': 'ING Direct',     '1491': 'Openbank',         '0073': 'Caixa Galicia',
  '0030': 'Banco de España', '0061': 'Banca March',     '6016': 'Triodos Bank',
};
function detectarBanco(iban) {
  const clean = iban.replace(/\s/g, '');
  return clean.length >= 8 ? (BANCOS[clean.slice(4, 8)] || null) : null;
}
function formatIBAN(raw) {
  const clean = raw.replace(/\s/g, '').toUpperCase().slice(0, 24);
  return clean.match(/.{1,4}/g)?.join(' ') || clean;
}

// ── Signature canvas ──────────────────────────────────────────────────────────
function FirmaCanvas({ onFirma, t }) {
  const ref     = useRef(null);
  const drawing = useRef(false);
  const [signed, setSigned] = useState(false);

  const getPos = (e, canvas) => {
    const rect = canvas.getBoundingClientRect();
    const src  = e.touches?.[0] || e;
    return {
      x: (src.clientX - rect.left) * (canvas.width  / rect.width),
      y: (src.clientY - rect.top)  * (canvas.height / rect.height),
    };
  };

  const start = useCallback((e) => {
    e.preventDefault();
    drawing.current = true;
    const canvas = ref.current;
    const ctx    = canvas.getContext('2d');
    const { x, y } = getPos(e, canvas);
    ctx.beginPath(); ctx.moveTo(x, y);
  }, []);

  const draw = useCallback((e) => {
    e.preventDefault();
    if (!drawing.current) return;
    const canvas = ref.current;
    const ctx    = canvas.getContext('2d');
    const { x, y } = getPos(e, canvas);
    ctx.lineTo(x, y);
    ctx.strokeStyle = '#111827'; ctx.lineWidth = 2.5;
    ctx.lineJoin = 'round'; ctx.lineCap = 'round';
    ctx.stroke();
    if (!signed) setSigned(true);
  }, [signed]);

  const end = useCallback(() => {
    drawing.current = false;
    if (signed) onFirma(ref.current.toDataURL('image/png'));
  }, [signed, onFirma]);

  const clear = () => {
    const canvas = ref.current;
    canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
    setSigned(false);
    onFirma(null);
  };

  return (
    <div>
      <canvas
        ref={ref}
        width={600} height={180}
        className="w-full border-2 border-dashed border-gray-300 rounded-xl bg-white cursor-crosshair"
        style={{ touchAction: 'none' }}
        onMouseDown={start} onMouseMove={draw} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={draw} onTouchEnd={end}
      />
      <div className="flex justify-between items-center mt-1.5">
        <p className="text-xs text-gray-400">{t.signCanvas}</p>
        <button onClick={clear} className="text-xs text-gray-500 hover:text-red-600 transition-colors underline">
          {t.signClear}
        </button>
      </div>
    </div>
  );
}

// ── Contrato completo (texto legal) ───────────────────────────────────────────

// Dirección real de la empresa (config/empresa) para la frase de
// identificación de LA EMPRESA en cada idioma — antes decía "Sevilla" fijo,
// que no es la dirección real. Sin config cargada, no se afirma ninguna
// dirección concreta.
function direccionEmpresa(cfg) {
  if (!cfg?.direccion) return null;
  const cpLoc = [cfg.cp, cfg.localidad].filter(Boolean).join(' ');
  return `${cfg.direccion}${cpLoc ? `, ${cpLoc}` : ''}`;
}
function razonSocialEmpresa(cfg) {
  return cfg?.nombre ? ` (${cfg.nombre}${cfg.nif ? `, NIF ${cfg.nif}` : ''})` : '';
}

const CONTRACT_TEXTS = {
  es: {
    title: 'CONTRATO DE MANTENIMIENTO ANUAL',
    reunidos: 'REUNIDOS', acuerdan: 'ACUERDAN',
    empresa: (cfg) => `De una parte, CLIMATIZACIÓN ZAPATA${razonSocialEmpresa(cfg)}, empresa de servicios de climatización y aerotermia, SAT oficial Ariston, con domicilio en ${direccionEmpresa(cfg) || 'la dirección fiscal registrada'} (en adelante, «LA EMPRESA»).`,
    clientePre: 'De otra parte, D./Dña. ',
    clientePost: (dir, mun, tel, email) => `${dir ? `, domicilio en ${dir},` : ','} ${mun}${tel ? `, Tel. ${tel}` : ''}${email ? `, correo: ${email}` : ''} (en adelante, «EL CLIENTE»).`,
    ambas: 'Ambas partes se reconocen capacidad legal suficiente para suscribir el presente contrato y, al efecto,',
    signedIn: 'En', signedOn: 'a',
    c1n:  'PRIMERA',    c1t:  'OBJETO DEL CONTRATO',
    c1b:  'El presente contrato tiene por objeto la prestación de servicios de mantenimiento preventivo anual de los equipos de climatización y/o aerotermia del CLIENTE en el domicilio indicado, así como la gestión de la extensión de garantía con el fabricante cuando el servicio contratado así lo contemple.',
    c2n:  'SEGUNDA',    c2t:  'SERVICIOS INCLUIDOS',
    c2b1: 'Revisión anual completa: parámetros de funcionamiento, estanqueidad y consumos eléctricos.',
    c2b2: 'Limpieza de filtros, intercambiadores y componentes accesibles del equipo.',
    c2b3: 'Informe técnico del estado del equipo tras cada visita.',
    c2b4: 'Coordinación de cita con el técnico asignado dentro del período de vigencia.',
    c3n:  'TERCERA',    c3t:  'DURACIÓN Y RENOVACIÓN',
    c3b:  'El contrato tiene una duración de DOCE (12) meses desde la fecha de firma. Al vencimiento se renovará automáticamente por períodos anuales, salvo que cualquiera de las partes comunique su voluntad de no renovarlo con un mínimo de TREINTA (30) días de antelación mediante comunicación escrita o correo electrónico a info@climatizacionzapata.es.',
    c4n:  'CUARTA',     c4t:  'PRECIO Y CONDICIONES DE PAGO',
    c4b:  (p, pIva) => `El precio anual del presente contrato asciende a ${p} € más IVA al tipo vigente del 21 %, lo que supone un total de ${pIva} € IVA incluido. El cobro se efectuará mediante domiciliación bancaria SEPA el día 10 de enero de cada año de vigencia; si dicho día no fuera hábil bancario, el cargo se realizará el siguiente día hábil inmediato. Para el primer año, el cargo se realizará en los treinta (30) días siguientes a la firma. En caso de devolución bancaria del cargo, LA EMPRESA podrá exigir el pago por otro medio y repercutir los gastos bancarios derivados.`,
    c4bVisita: (p, pIva) => `El precio anual del presente contrato asciende a ${p} € más IVA al tipo vigente del 21 %, lo que supone un total de ${pIva} € IVA incluido. El pago se realizará en efectivo o mediante tarjeta bancaria en el momento de la visita de mantenimiento, contra la entrega del correspondiente justificante o factura por parte de LA EMPRESA. En caso de no efectuarse el pago en el momento de la visita, LA EMPRESA podrá reclamar su abono por cualquier medio admitido en derecho, quedando en tal caso condicionada la realización de futuras visitas al buen fin del cobro.`,
    c5n:  'QUINTA',     c5t:  'MANDATO DE DOMICILIACIÓN BANCARIA SEPA',
    c5b:  (ref) => `EL CLIENTE autoriza expresamente a Climatización Zapata a emitir órdenes de cobro SEPA con carácter recurrente por el importe anual establecido, con cargo a la cuenta bancaria domiciliada cuyo titular es EL CLIENTE. Esta autorización se renovará automáticamente junto con el contrato. Referencia única de mandato: ${ref}. EL CLIENTE podrá solicitar la devolución del cargo ante su entidad bancaria en el plazo de ocho (8) semanas desde la fecha de adeudo, conforme a la normativa SEPA vigente.`,
    c5tVisita: 'JUSTIFICANTE Y ACREDITACIÓN DEL PAGO',
    c5bVisita: 'El pago realizado conforme a la cláusula anterior quedará acreditado mediante el justificante o factura emitido por LA EMPRESA en el momento del cobro. EL CLIENTE podrá solicitar dicho justificante y conservarlo como comprobante de la operación.',
    c6n:  'SEXTA',      c6t:  'OBLIGACIONES DE LA EMPRESA',
    c6b1: 'Realizar la revisión anual dentro del período de vigencia, previo acuerdo de cita con EL CLIENTE.',
    c6b2: 'Comunicar con antelación suficiente la fecha y hora de la visita programada.',
    c6b3: 'Emitir parte de trabajo e informe técnico tras cada revisión.',
    c6b4: 'Gestionar la extensión de garantía con el fabricante cuando el contrato lo contemple.',
    c6b5: 'Mantener la confidencialidad de los datos del CLIENTE y de su instalación.',
    c7n:  'SÉPTIMA',    c7t:  'OBLIGACIONES DEL CLIENTE',
    c7b1: 'Facilitar el acceso del técnico al domicilio en la fecha y hora acordadas.',
    c7b2: 'Comunicar a LA EMPRESA cualquier anomalía, avería o modificación en el equipo.',
    c7b3: 'Notificar con antelación cambios en datos de contacto o en la cuenta bancaria domiciliada.',
    c7b4: 'No manipular, modificar ni reparar el equipo sin autorización del fabricante o de LA EMPRESA.',
    c7b5: 'Abonar el precio anual en las condiciones establecidas en la cláusula cuarta.',
    c8n:  'OCTAVA',     c8t:  'EXCLUSIONES',
    c8intro: 'Quedan expresamente excluidos del presente contrato:',
    c8b1: 'La sustitución de piezas, componentes o consumibles deteriorados o averiados.',
    c8b2: 'Los daños producidos por mal uso, negligencia, manipulación incorrecta o actuaciones de terceros.',
    c8b3: 'Las averías derivadas de causas externas (sobretensiones, inundaciones, fenómenos meteorológicos, etc.).',
    c8b4: 'Las reparaciones de defectos o daños preexistentes a la firma del contrato.',
    c8b5: 'Los desplazamientos de urgencia fuera del mantenimiento anual programado, salvo acuerdo expreso.',
    c8b6: 'La instalación de nuevos equipos o modificaciones de la instalación existente.',
    c9n:  'NOVENA',     c9t:  'MODIFICACIÓN DE PRECIOS',
    c9b:  'LA EMPRESA podrá actualizar el precio anual del contrato, comunicándolo al CLIENTE con un mínimo de TREINTA (30) días de antelación a la fecha de renovación. Si EL CLIENTE no estuviera conforme, podrá resolver el contrato sin penalización notificándolo dentro de los quince (15) días siguientes a la recepción de la comunicación.',
    c10n: 'DÉCIMA',     c10t: 'RESOLUCIÓN DEL CONTRATO',
    c10b: 'Cualquiera de las partes podrá resolver el contrato al término de cada período anual, con el preaviso establecido en la cláusula tercera. LA EMPRESA podrá resolver el contrato de forma inmediata en caso de impago reiterado o incumplimiento grave por parte del CLIENTE. La resolución no dará derecho a devolución de la parte proporcional del precio ya satisfecho.',
    c11n: 'UNDÉCIMA',   c11t: 'PROTECCIÓN DE DATOS PERSONALES',
    c11b: 'Los datos personales facilitados serán tratados por Climatización Zapata, como responsable del tratamiento, para gestionar la relación contractual y prestar los servicios contratados (base jurídica: ejecución del contrato). Los datos no serán cedidos a terceros salvo obligación legal. EL CLIENTE puede ejercer sus derechos de acceso, rectificación, supresión, limitación, portabilidad y oposición dirigiéndose a info@climatizacionzapata.es, conforme al Reglamento (UE) 2016/679 (RGPD) y la LOPDGDD.',
    c12n: 'DUODÉCIMA',  c12t: 'LEGISLACIÓN APLICABLE Y JURISDICCIÓN',
    c12b: 'El presente contrato se rige por la legislación española. Para la resolución de cualquier controversia derivada de su interpretación o cumplimiento, las partes se someten a los Juzgados y Tribunales del domicilio de EL CLIENTE, con renuncia expresa a cualquier otro fuero que pudiera corresponderles.',
  },
  en: {
    title: 'ANNUAL MAINTENANCE CONTRACT',
    reunidos: 'PARTIES', acuerdan: 'AGREE',
    empresa: (cfg) => `On one side, CLIMATIZACIÓN ZAPATA${razonSocialEmpresa(cfg)}, a climatisation and aerothermy services company, official Ariston SAT, with registered office at ${direccionEmpresa(cfg) || 'its registered tax address'} (hereinafter, «THE COMPANY»).`,
    clientePre: 'On the other side, Mr./Ms. ',
    clientePost: (dir, mun, tel, email) => `${dir ? `, residing at ${dir},` : ','} ${mun}${tel ? `, Tel. ${tel}` : ''}${email ? `, email: ${email}` : ''} (hereinafter, «THE CLIENT»).`,
    ambas: 'Both parties acknowledge having sufficient legal capacity to enter into this contract and, to that effect,',
    signedIn: 'In', signedOn: 'on',
    c1n:  'FIRST',      c1t:  'SUBJECT MATTER',
    c1b:  "This contract covers the provision of annual preventive maintenance services for THE CLIENT's climatisation and/or aerothermy equipment at the indicated address, as well as the management of warranty extensions with the manufacturer where the contracted service includes this.",
    c2n:  'SECOND',     c2t:  'INCLUDED SERVICES',
    c2b1: 'Full annual inspection: operating parameters, leak checks and electrical consumption.',
    c2b2: 'Cleaning of filters, heat exchangers and accessible components.',
    c2b3: 'Technical report on equipment condition after each visit.',
    c2b4: 'Scheduling of appointment with the assigned technician within the contract period.',
    c3n:  'THIRD',      c3t:  'TERM AND RENEWAL',
    c3b:  'The contract has a term of TWELVE (12) months from the signing date. Upon expiry it will automatically renew for successive annual periods, unless either party gives notice of non-renewal at least THIRTY (30) days in advance by written communication or email to info@climatizacionzapata.es.',
    c4n:  'FOURTH',     c4t:  'PRICE AND PAYMENT CONDITIONS',
    c4b:  (p, pIva) => `The annual price of this contract is ${p} € plus VAT at the current rate of 21%, making a total of ${pIva} € VAT included. Payment will be collected by SEPA direct debit on January 10th each year; if that date is not a banking business day, the charge will be made on the next available business day. For the first year, the charge will be made within thirty (30) days of signing. In the event of a bank return of the charge, THE COMPANY may demand payment by another means and recover any resulting bank charges.`,
    c4bVisita: (p, pIva) => `The annual price of this contract is ${p} € plus VAT at the current rate of 21%, making a total of ${pIva} € VAT included. Payment shall be made in cash or by card at the time of the maintenance visit, against the corresponding receipt or invoice issued by THE COMPANY. If payment is not made at the time of the visit, THE COMPANY may claim payment by any other legally admissible means, and future visits may be made conditional on the payment being settled.`,
    c5n:  'FIFTH',      c5t:  'SEPA DIRECT DEBIT MANDATE',
    c5b:  (ref) => `THE CLIENT expressly authorises Climatización Zapata to issue recurring SEPA direct debit orders for the established annual amount, charged to the direct debit bank account held by THE CLIENT. This authorisation will automatically renew together with the contract. Unique mandate reference: ${ref}. THE CLIENT may request a refund of the charge from their bank within eight (8) weeks of the debit date, in accordance with current SEPA regulations.`,
    c5tVisita: 'PROOF AND EVIDENCE OF PAYMENT',
    c5bVisita: 'Payment made under the previous clause shall be evidenced by the receipt or invoice issued by THE COMPANY at the time of collection. THE CLIENT may request and keep this receipt as proof of the transaction.',
    c6n:  'SIXTH',      c6t:  "COMPANY'S OBLIGATIONS",
    c6b1: 'Carry out the annual inspection within the contract period, by prior appointment with THE CLIENT.',
    c6b2: 'Give sufficient advance notice of the scheduled visit date and time.',
    c6b3: 'Issue a job sheet and technical report after each inspection.',
    c6b4: 'Manage the warranty extension with the manufacturer where covered by the contract.',
    c6b5: "Maintain the confidentiality of THE CLIENT's data and installation.",
    c7n:  'SEVENTH',    c7t:  "CLIENT'S OBLIGATIONS",
    c7b1: 'Provide the technician with access to the premises at the agreed date and time.',
    c7b2: 'Notify THE COMPANY of any fault, breakdown or modification to the equipment.',
    c7b3: 'Give advance notice of changes to contact details or the direct debit bank account.',
    c7b4: 'Not to tamper with, modify or repair the equipment without authorisation from the manufacturer or THE COMPANY.',
    c7b5: 'Pay the annual price under the conditions set out in clause four.',
    c8n:  'EIGHTH',     c8t:  'EXCLUSIONS',
    c8intro: 'The following are expressly excluded from this contract:',
    c8b1: 'Replacement of worn or damaged parts, components or consumables.',
    c8b2: 'Damage caused by misuse, negligence, incorrect handling or third-party actions.',
    c8b3: 'Faults arising from external causes (power surges, flooding, weather events, etc.).',
    c8b4: 'Repairs of defects or damage pre-existing at the time of signing.',
    c8b5: 'Emergency call-outs outside the scheduled annual maintenance, unless expressly agreed.',
    c8b6: 'Installation of new equipment or modifications to the existing installation.',
    c9n:  'NINTH',      c9t:  'PRICE MODIFICATIONS',
    c9b:  "THE COMPANY may update the annual contract price, giving THE CLIENT at least THIRTY (30) days' notice before the renewal date. If THE CLIENT does not agree, they may terminate the contract without penalty by giving notice within fifteen (15) days of receiving the communication.",
    c10n: 'TENTH',      c10t: 'TERMINATION',
    c10b: 'Either party may terminate the contract at the end of each annual period with the notice set out in clause three. THE COMPANY may terminate the contract immediately in the event of repeated non-payment or serious breach by THE CLIENT. Termination shall not entitle either party to a refund of the proportional portion of the price already paid.',
    c11n: 'ELEVENTH',   c11t: 'PERSONAL DATA PROTECTION',
    c11b: 'Personal data provided will be processed by Climatización Zapata as data controller to manage the contractual relationship and provide the contracted services (legal basis: performance of contract). Data will not be shared with third parties except as required by law. THE CLIENT may exercise their rights of access, rectification, erasure, restriction, portability and objection by writing to info@climatizacionzapata.es, in accordance with Regulation (EU) 2016/679 (GDPR) and Spanish data protection law.',
    c12n: 'TWELFTH',    c12t: 'APPLICABLE LAW AND JURISDICTION',
    c12b: "This contract is governed by Spanish law. For the resolution of any dispute arising from its interpretation or performance, the parties submit to the Courts and Tribunals of THE CLIENT's domicile, expressly waiving any other jurisdiction that may apply to them.",
  },
  fr: {
    title: 'CONTRAT DE MAINTENANCE ANNUELLE',
    reunidos: 'PARTIES', acuerdan: 'CONVIENNENT',
    empresa: (cfg) => `D'une part, CLIMATIZACIÓN ZAPATA${razonSocialEmpresa(cfg)}, société de services de climatisation et d'aérothermie, SAT officiel Ariston, dont le siège est situé à ${direccionEmpresa(cfg) || "l'adresse fiscale enregistrée"} (ci-après dénommée «L'ENTREPRISE»).`,
    clientePre: "D'autre part, M./Mme ",
    clientePost: (dir, mun, tel, email) => `${dir ? `, domicilié(e) au ${dir},` : ','} ${mun}${tel ? `, Tél. ${tel}` : ''}${email ? `, courriel : ${email}` : ''} (ci-après dénommé(e) «LE CLIENT»).`,
    ambas: "Les deux parties se reconnaissent la capacité juridique suffisante pour conclure le présent contrat et, à cet effet,",
    signedIn: 'À', signedOn: 'le',
    c1n:  'PREMIÈRE',   c1t:  'OBJET DU CONTRAT',
    c1b:  "Le présent contrat a pour objet la prestation de services de maintenance préventive annuelle des équipements de climatisation et/ou d'aérothermie du CLIENT à l'adresse indiquée, ainsi que la gestion de l'extension de garantie auprès du fabricant lorsque le service contracté le prévoit.",
    c2n:  'DEUXIÈME',   c2t:  'SERVICES INCLUS',
    c2b1: "Inspection annuelle complète : paramètres de fonctionnement, contrôle d'étanchéité et consommations électriques.",
    c2b2: "Nettoyage des filtres, échangeurs thermiques et composants accessibles de l'équipement.",
    c2b3: "Rapport technique sur l'état de l'équipement après chaque visite.",
    c2b4: "Prise de rendez-vous avec le technicien désigné dans le délai de validité du contrat.",
    c3n:  'TROISIÈME',  c3t:  'DURÉE ET RENOUVELLEMENT',
    c3b:  "Le contrat a une durée de DOUZE (12) mois à compter de la date de signature. À son échéance, il sera automatiquement renouvelé par périodes annuelles successives, sauf si l'une ou l'autre des parties communique sa volonté de ne pas le renouveler au moins TRENTE (30) jours à l'avance par écrit ou courriel à info@climatizacionzapata.es.",
    c4n:  'QUATRIÈME',  c4t:  'PRIX ET CONDITIONS DE PAIEMENT',
    c4b:  (p, pIva) => `Le prix annuel du présent contrat s'élève à ${p} € hors TVA au taux en vigueur de 21 %, soit un total de ${pIva} € TVA incluse. Le paiement sera effectué par prélèvement automatique SEPA le 10 janvier de chaque année de validité ; si ce jour n'est pas un jour ouvré bancaire, le prélèvement sera effectué le jour ouvré suivant. Pour la première année, le prélèvement sera réalisé dans les trente (30) jours suivant la signature. En cas de rejet bancaire, L'ENTREPRISE pourra exiger le paiement par un autre moyen et répercuter les frais bancaires en résultant.`,
    c4bVisita: (p, pIva) => `Le prix annuel du présent contrat s'élève à ${p} € hors TVA au taux en vigueur de 21 %, soit un total de ${pIva} € TVA incluse. Le paiement sera effectué en espèces ou par carte bancaire au moment de la visite de maintenance, contre remise du justificatif ou de la facture correspondante par L'ENTREPRISE. À défaut de paiement au moment de la visite, L'ENTREPRISE pourra réclamer son règlement par tout autre moyen admis en droit, la réalisation des visites futures pouvant alors être conditionnée au règlement effectif du paiement.`,
    c5n:  'CINQUIÈME',  c5t:  'MANDAT DE PRÉLÈVEMENT BANCAIRE SEPA',
    c5b:  (ref) => `LE CLIENT autorise expressément Climatización Zapata à émettre des ordres de prélèvement SEPA récurrents pour le montant annuel établi, débité sur le compte bancaire domicilié dont le titulaire est LE CLIENT. Cette autorisation sera automatiquement renouvelée avec le contrat. Référence unique de mandat : ${ref}. LE CLIENT pourra demander le remboursement du prélèvement à sa banque dans un délai de huit (8) semaines à compter de la date d'échéance, conformément à la réglementation SEPA en vigueur.`,
    c5tVisita: 'JUSTIFICATIF ET PREUVE DE PAIEMENT',
    c5bVisita: "Le paiement effectué conformément à la clause précédente sera attesté par le justificatif ou la facture émis par L'ENTREPRISE au moment de l'encaissement. LE CLIENT pourra demander ce justificatif et le conserver comme preuve de l'opération.",
    c6n:  'SIXIÈME',    c6t:  "OBLIGATIONS DE L'ENTREPRISE",
    c6b1: "Effectuer l'inspection annuelle dans le délai de validité du contrat, après accord préalable de rendez-vous avec LE CLIENT.",
    c6b2: "Communiquer suffisamment à l'avance la date et l'heure de la visite programmée.",
    c6b3: "Émettre un bon d'intervention et un rapport technique après chaque inspection.",
    c6b4: "Gérer l'extension de garantie auprès du fabricant lorsque le contrat le prévoit.",
    c6b5: "Maintenir la confidentialité des données du CLIENT et de son installation.",
    c7n:  'SEPTIÈME',   c7t:  'OBLIGATIONS DU CLIENT',
    c7b1: "Permettre l'accès du technicien au domicile à la date et à l'heure convenues.",
    c7b2: "Notifier à L'ENTREPRISE toute anomalie, panne ou modification de l'équipement.",
    c7b3: "Signaler à l'avance tout changement de coordonnées ou de compte bancaire domicilié.",
    c7b4: "Ne pas manipuler, modifier ou réparer l'équipement sans autorisation du fabricant ou de L'ENTREPRISE.",
    c7b5: "Payer le prix annuel dans les conditions fixées à la quatrième clause.",
    c8n:  'HUITIÈME',   c8t:  'EXCLUSIONS',
    c8intro: 'Sont expressément exclus du présent contrat :',
    c8b1: "Le remplacement de pièces, composants ou consommables détériorés ou défectueux.",
    c8b2: "Les dommages causés par une mauvaise utilisation, une négligence, une manipulation incorrecte ou des actes de tiers.",
    c8b3: "Les pannes résultant de causes externes (surtensions, inondations, phénomènes météorologiques, etc.).",
    c8b4: "La réparation de défauts ou dommages préexistants à la signature du contrat.",
    c8b5: "Les déplacements d'urgence en dehors de la maintenance annuelle programmée, sauf accord exprès.",
    c8b6: "L'installation de nouveaux équipements ou les modifications de l'installation existante.",
    c9n:  'NEUVIÈME',   c9t:  'MODIFICATION DES PRIX',
    c9b:  "L'ENTREPRISE pourra mettre à jour le prix annuel du contrat, en informant LE CLIENT au moins TRENTE (30) jours avant la date de renouvellement. Si LE CLIENT n'est pas d'accord, il pourra résilier le contrat sans pénalité en le notifiant dans les quinze (15) jours suivant la réception de la communication.",
    c10n: 'DIXIÈME',    c10t: 'RÉSILIATION DU CONTRAT',
    c10b: "L'une ou l'autre des parties peut résilier le contrat à l'issue de chaque période annuelle, avec le préavis prévu à la troisième clause. L'ENTREPRISE peut résilier le contrat immédiatement en cas de non-paiement répété ou de manquement grave de la part du CLIENT. La résiliation n'ouvre pas droit au remboursement de la part du prix déjà versée.",
    c11n: 'ONZIÈME',    c11t: 'PROTECTION DES DONNÉES PERSONNELLES',
    c11b: "Les données personnelles fournies seront traitées par Climatización Zapata en tant que responsable du traitement pour gérer la relation contractuelle et fournir les services contractés (base légale : exécution du contrat). Les données ne seront pas transmises à des tiers sauf obligation légale. LE CLIENT peut exercer ses droits d'accès, de rectification, d'effacement, de limitation, de portabilité et d'opposition en écrivant à info@climatizacionzapata.es, conformément au Règlement (UE) 2016/679 (RGPD) et à la loi espagnole sur la protection des données.",
    c12n: 'DOUZIÈME',   c12t: 'LOI APPLICABLE ET JURIDICTION',
    c12b: "Le présent contrat est régi par la loi espagnole. Pour la résolution de tout litige découlant de son interprétation ou de son exécution, les parties se soumettent aux Tribunaux du domicile du CLIENT, renonçant expressément à tout autre for qui pourrait leur être applicable.",
  },
};

function Clausula({ num, titulo, children }) {
  return (
    <div className="mt-4">
      <p className="font-bold text-red-700 text-xs uppercase tracking-wide">{num}. {titulo}</p>
      <div className="h-px bg-red-200 w-2/5 mt-0.5 mb-2" />
      <div className="space-y-1.5">{children}</div>
    </div>
  );
}
function Bala({ children }) {
  return (
    <p className="text-xs text-gray-600 leading-relaxed flex gap-1.5">
      <span className="text-gray-400 flex-shrink-0 mt-0.5">•</span>
      <span>{children}</span>
    </p>
  );
}
function ContratoTexto({ contrato, lang, empresa }) {
  const ct           = CONTRACT_TEXTS[lang] || CONTRACT_TEXTS.es;
  const locale       = lang === 'fr' ? 'fr-FR' : lang === 'en' ? 'en-GB' : 'es-ES';
  const today        = new Date().toLocaleDateString(locale);
  const precioSinIva = Number(contrato?.precioAnual) || 0;
  const precioConIva = (precioSinIva * 1.21).toFixed(2).replace('.', ',');
  const precioFmt    = precioSinIva.toFixed(2).replace('.', ',');
  const servicios    = contrato?.serviciosIncluidos || [];
  const esVisita     = contrato?.modoCobro === 'visita';
  const refSepa      = contrato?.referenciaMandatoSepa || '—';
  const refCabecera  = esVisita ? (contrato?.referenciaContrato || '—') : refSepa;

  return (
    <div className="mt-4 text-xs text-gray-600 leading-relaxed space-y-1.5 border border-gray-200 rounded-xl p-4 bg-gray-50 max-h-[70vh] overflow-y-auto">
      {/* Cabecera */}
      <div className="text-center pb-3 border-b border-gray-200 mb-2">
        <p className="font-black text-red-700 text-sm tracking-wide">CLIMATIZACIÓN ZAPATA</p>
        <p className="text-gray-700 font-semibold mt-0.5">{ct.title}</p>
        <p className="text-gray-400 text-xs mt-1">{esVisita ? 'Ref. contrato' : 'Ref. SEPA'}: {refCabecera}</p>
      </div>

      {/* Reunidos / Parties */}
      <p className="font-bold text-gray-800 uppercase tracking-wide">{ct.reunidos}</p>
      <p>{ct.empresa(empresa)}</p>
      <p>
        {ct.clientePre}<strong>{contrato?.clienteNombre || ''}</strong>
        {ct.clientePost(contrato?.direccion || '', contrato?.municipio || '', contrato?.clienteTelefono, contrato?.clienteEmail)}
      </p>
      <p>{ct.ambas}</p>
      <p className="font-bold text-gray-800 uppercase tracking-wide text-center mt-3">{ct.acuerdan}</p>

      <Clausula num={ct.c1n} titulo={ct.c1t}><p>{ct.c1b}</p></Clausula>

      <Clausula num={ct.c2n} titulo={ct.c2t}>
        {servicios.map((s, i) => <Bala key={i}>{s}</Bala>)}
        <Bala>{ct.c2b1}</Bala>
        <Bala>{ct.c2b2}</Bala>
        <Bala>{ct.c2b3}</Bala>
        <Bala>{ct.c2b4}</Bala>
      </Clausula>

      <Clausula num={ct.c3n}  titulo={ct.c3t}><p>{ct.c3b}</p></Clausula>
      <Clausula num={ct.c4n}  titulo={ct.c4t}>
        <p>{esVisita ? ct.c4bVisita(precioFmt, precioConIva) : ct.c4b(precioFmt, precioConIva)}</p>
      </Clausula>
      <Clausula num={ct.c5n}  titulo={esVisita ? ct.c5tVisita : ct.c5t}>
        <p>{esVisita ? ct.c5bVisita : ct.c5b(refSepa)}</p>
      </Clausula>

      <Clausula num={ct.c6n} titulo={ct.c6t}>
        <Bala>{ct.c6b1}</Bala><Bala>{ct.c6b2}</Bala><Bala>{ct.c6b3}</Bala>
        <Bala>{ct.c6b4}</Bala><Bala>{ct.c6b5}</Bala>
      </Clausula>

      <Clausula num={ct.c7n} titulo={ct.c7t}>
        <Bala>{ct.c7b1}</Bala><Bala>{ct.c7b2}</Bala><Bala>{ct.c7b3}</Bala>
        <Bala>{ct.c7b4}</Bala><Bala>{ct.c7b5}</Bala>
      </Clausula>

      <Clausula num={ct.c8n} titulo={ct.c8t}>
        <p className="mb-1">{ct.c8intro}</p>
        <Bala>{ct.c8b1}</Bala><Bala>{ct.c8b2}</Bala><Bala>{ct.c8b3}</Bala>
        <Bala>{ct.c8b4}</Bala><Bala>{ct.c8b5}</Bala><Bala>{ct.c8b6}</Bala>
      </Clausula>

      <Clausula num={ct.c9n}  titulo={ct.c9t}><p>{ct.c9b}</p></Clausula>
      <Clausula num={ct.c10n} titulo={ct.c10t}><p>{ct.c10b}</p></Clausula>
      <Clausula num={ct.c11n} titulo={ct.c11t}><p>{ct.c11b}</p></Clausula>
      <Clausula num={ct.c12n} titulo={ct.c12t}><p>{ct.c12b}</p></Clausula>

      <div className="pt-3 mt-3 border-t border-gray-200 text-gray-500">
        <p>{ct.signedIn} {contrato?.municipio || '___________'}, {ct.signedOn} {today}</p>
      </div>
    </div>
  );
}

// ── Main component ────────────────────────────────────────────────────────────
export default function FirmaPublica({ token }) {
  const [lang,       setLang]      = useState(detectLang);
  const t = LANGS[lang];

  const [fase,       setFase]      = useState('cargando');
  const [errorMsg,   setErrorMsg]  = useState('');
  const [contrato,   setContrato]  = useState(null);
  const [empresa,    setEmpresa]   = useState(null); // { nombre, nif, direccion, cp, localidad } — config/empresa real

  const [dni,        setDni]       = useState('');
  const [iban,       setIban]      = useState('');
  const [ibanConf,   setIbanConf]  = useState('');
  const [bic,        setBic]       = useState('');
  const [titular,    setTitular]   = useState('');
  const [firmaB64,       setFirmaB64]       = useState(null);
  const [checkA,         setCheckA]         = useState(false);
  const [checkB,         setCheckB]         = useState(false);
  const [checkC,         setCheckC]         = useState(false); // comunicaciones comerciales — OPT-IN, no obligatorio (RGPD)
  const [email,          setEmail]          = useState('');
  const [codigoCom,      setCodigoCom]      = useState('');
  const [comVerif,       setComVerif]       = useState(null); // null | { valid, nombre, faltan, descuentoActivo, descuentoPct }
  const [verificandoCom, setVerificandoCom] = useState(false);
  const [codigoSoc,      setCodigoSoc]      = useState('');
  const [socVerif,       setSocVerif]       = useState(null); // null | { valid, nombre }
  const [verificandoSoc, setVerificandoSoc] = useState(false);

  const [expandido,      setExpandido]      = useState(false);
  const [mostrarContrato, setMostrarContrato] = useState(false);
  const [sending,        setSending]         = useState(false);

  const ibanClean   = iban.replace(/\s/g, '');
  const ibanValido  = validarIBAN(ibanClean);
  const ibanCoincide= ibanClean === ibanConf.replace(/\s/g, '');
  const banco       = ibanValido ? detectarBanco(ibanClean) : null;
  const dniClean    = dni.trim().toUpperCase();
  const dniValido   = dniClean.length >= 4 && dniClean.length <= 20 && /^[A-Z0-9\-]{4,20}$/.test(dniClean);
  const emailValido = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  const esVisita     = contrato?.modoCobro === 'visita';
  const puedeEnviar = dniValido && emailValido && (esVisita || (ibanValido && ibanCoincide)) && checkA && (esVisita || checkB) && firmaB64 && !sending;
  const precioBase  = Number(contrato?.precioAnual || 0);
  const precio      = precioBase.toFixed(2).replace('.', ',');
  const precioConIva = (precioBase * 1.21).toFixed(2).replace('.', ',');

  useEffect(() => {
    if (!token) { setFase('error'); setErrorMsg('Token inválido'); return; }
    fetch(`/.netlify/functions/procesarFirmaPublica?token=${token}`)
      .then(r => r.json())
      .then(d => {
        if (!d.success) { setFase('error'); setErrorMsg(d.error || 'Error'); return; }
        setContrato(d.contratoData);
        setEmpresa(d.empresa || null);
        setTitular(d.contratoData?.clienteNombre || '');
        setFase('listo');
      })
      .catch(() => { setFase('error'); setErrorMsg('Error de conexión'); });
  }, [token]);

  const handleFirmar = async () => {
    if (!puedeEnviar) return;
    setSending(true);
    try {
      const r = await fetch('/.netlify/functions/procesarFirmaPublica', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, dni: dniClean, email: email.trim(), iban: ibanClean, bic, titularCuenta: titular, firmaBase64: firmaB64, codigoComunidad: codigoCom.trim().toUpperCase() || undefined, codigoSocio: codigoSoc.trim().toUpperCase() || undefined, consentimientoComercial: checkC }),
      });
      const d = await r.json();
      if (!d.success) throw new Error(d.error || 'Error');
      setFase('exito');
    } catch (e) {
      setErrorMsg(e.message);
    } finally {
      setSending(false);
    }
  };

  // ── Selector de idioma ──────────────────────────────────────────────────────
  const LangBtn = ({ code, flag }) => (
    <button
      onClick={() => setLang(code)}
      className={`px-2 py-1 rounded-lg text-sm font-bold transition-colors ${
        lang === code ? 'bg-red-600 text-white' : 'text-gray-500 hover:bg-gray-100'
      }`}
    >
      {flag}
    </button>
  );

  // ── Render ──────────────────────────────────────────────────────────────────
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-10">
        <div className="max-w-lg mx-auto px-4 py-3 flex items-center gap-3">
          <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
            <img src={zapataLogo} alt="Climatización Zapata" className="w-8 h-8 object-contain" />
          </div>
          <div className="flex-1">
            <p className="text-xs text-gray-500 leading-none">Climatización Zapata</p>
            <p className="text-sm font-bold text-gray-900 leading-tight">{t.headerSubtitle}</p>
          </div>
          <div className="flex gap-0.5">
            <LangBtn code="es" flag="🇪🇸" />
            <LangBtn code="en" flag="🇬🇧" />
            <LangBtn code="fr" flag="🇫🇷" />
          </div>
        </div>
      </header>

      <main className="max-w-lg mx-auto px-4 py-6 space-y-5">

        {/* Loading */}
        {fase === 'cargando' && (
          <div className="flex flex-col items-center py-16 gap-3">
            <div className="w-10 h-10 border-4 border-gray-200 border-t-red-600 rounded-full animate-spin" />
            <p className="text-gray-500 text-sm">{t.loading}</p>
          </div>
        )}

        {/* Error */}
        {fase === 'error' && (
          <div className="bg-red-50 border border-red-200 rounded-2xl p-6 text-center">
            <div className="text-3xl mb-3">⚠️</div>
            <p className="font-bold text-red-800 mb-2">{errorMsg}</p>
            <p className="text-sm text-red-600">{t.errorContact}</p>
          </div>
        )}

        {/* Éxito */}
        {fase === 'exito' && (
          <div className="bg-green-50 border border-green-200 rounded-2xl p-8 text-center">
            <div className="text-4xl mb-4">✅</div>
            <h2 className="text-xl font-bold text-green-800 mb-2">{t.successTitle}</h2>
            <p className="text-green-700 text-sm mb-4">
              {contrato?.clienteEmail ? t.successEmail(contrato.clienteEmail) : t.successReg}
            </p>
            <p className="text-sm text-green-600 mb-1">{t.successActive}</p>
            <p className="text-sm text-green-600">{esVisita ? t.successChargeVisita : t.successCharge(precioConIva)}</p>
            <hr className="my-5 border-green-200" />
            <p className="text-xs text-gray-500">{t.successThanks}</p>
          </div>
        )}

        {/* Formulario */}
        {(fase === 'listo' || fase === 'firmando') && contrato && (
          <>
            {/* Resumen del contrato */}
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
              <div className="px-5 py-4 border-b border-gray-100 flex justify-between items-center cursor-pointer" onClick={() => setExpandido(e => !e)}>
                <div>
                  <p className="font-bold text-gray-900">{contrato.clienteNombre}</p>
                  <p className="text-sm text-gray-500">{contrato.direccion ? `${contrato.direccion} · ` : ''}{contrato.municipio}</p>
                </div>
                <span className="text-gray-400 text-lg">{expandido ? '▲' : '▼'}</span>
              </div>
              {expandido && (
                <div className="px-5 py-4 space-y-3 text-sm">
                  <div>
                    <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-1.5">{t.services}</p>
                    <ul className="space-y-1">
                      {(contrato.serviciosIncluidos || []).map((s, i) => (
                        <li key={i} className="flex items-center gap-2 text-gray-700">
                          <span className="text-green-500">✓</span> {s}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="bg-gray-50 rounded-xl px-4 py-3 space-y-0.5">
                    <div className="flex justify-between items-center">
                      <span className="text-gray-600 text-sm">{t.annualPrice}</span>
                      <span className="font-bold text-gray-900 text-lg">{precioConIva}€</span>
                    </div>
                    <p className="text-xs text-gray-400 text-right">{precio}€ + IVA 21%</p>
                  </div>
                  <p className="text-xs text-gray-500 text-center">
                    {esVisita ? t.sepaRefVisita : t.sepaRef} {esVisita ? (contrato.referenciaContrato || '—') : contrato.referenciaMandatoSepa}
                  </p>
                </div>
              )}
            </div>

            {/* Contrato completo */}
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
              <button
                className="w-full px-5 py-4 flex justify-between items-center text-left"
                onClick={() => setMostrarContrato(c => !c)}
              >
                <div className="flex items-center gap-2">
                  <span className="text-base">📄</span>
                  <span className="font-semibold text-gray-900 text-sm">{t.seeConditions}</span>
                </div>
                <span className="text-gray-400 text-sm">{mostrarContrato ? '▲' : '▼'}</span>
              </button>
              {mostrarContrato && (
                <div className="px-4 pb-4">
                  <ContratoTexto contrato={contrato} lang={lang} empresa={empresa} />
                </div>
              )}
            </div>

            {/* Datos de contacto (+ datos bancarios si aplica) */}
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 px-5 py-5 space-y-4">
              <h3 className="font-bold text-gray-900">{esVisita ? t.contactSection : t.bankSection}</h3>

              {/* DNI */}
              <div className="space-y-1">
                <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider">{t.dniLabel}</label>
                <input
                  value={dni}
                  onChange={e => setDni(e.target.value.toUpperCase())}
                  placeholder={t.dniPlaceholder}
                  maxLength={20}
                  className={`w-full border rounded-xl px-3 py-2.5 text-sm font-mono focus:outline-none transition-colors ${
                    dni.length > 0 ? (dniValido ? 'border-green-400 bg-green-50' : 'border-amber-300 bg-amber-50') : 'border-gray-200 focus:border-red-400'
                  }`}
                />
                {dni.length > 0 && !dniValido && <p className="text-xs text-red-600 mt-0.5">{t.dniHint}</p>}
                {dniValido && <p className="text-xs text-green-600 mt-0.5">{t.dniOk}</p>}
              </div>

              {/* Email */}
              <div className="space-y-1">
                <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider">{t.emailLabel}</label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="ejemplo@correo.com"
                  maxLength={100}
                  className={`w-full border rounded-xl px-3 py-2.5 text-sm focus:outline-none transition-colors ${
                    email.length > 0 ? (emailValido ? 'border-green-400 bg-green-50' : 'border-amber-300 bg-amber-50') : 'border-gray-200 focus:border-red-400'
                  }`}
                />
                {email.length > 0 && !emailValido && <p className="text-xs text-red-600 mt-0.5">{t.emailHint}</p>}
                {emailValido && <p className="text-xs text-green-600 mt-0.5">{t.emailOk}</p>}
              </div>

              {!esVisita && (
                <>
                  {/* IBAN */}
                  <div className="space-y-1">
                    <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider">{t.ibanLabel}</label>
                    <input
                      value={formatIBAN(iban)}
                      onChange={e => setIban(e.target.value.replace(/\s/g, ''))}
                      placeholder="ES00 0000 0000 0000 0000 0000"
                      maxLength={40}
                      className={`w-full border rounded-xl px-3 py-2.5 text-sm font-mono focus:outline-none transition-colors ${
                        ibanClean.length >= 15 ? (ibanValido ? 'border-green-400 bg-green-50' : 'border-red-400 bg-red-50') : 'border-gray-200 focus:border-red-400'
                      }`}
                    />
                    {ibanValido && banco && <p className="text-xs text-green-600 mt-0.5">✓ {banco}</p>}
                    {ibanValido && !banco && <p className="text-xs text-green-600 mt-0.5">✓ IBAN válido</p>}
                    {ibanClean.length >= 15 && !ibanValido && <p className="text-xs text-red-600 mt-0.5">{t.ibanInvalid}</p>}
                  </div>

                  {/* Confirmar IBAN */}
                  <div className="space-y-1">
                    <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider">{t.ibanConfLabel}</label>
                    <input
                      value={formatIBAN(ibanConf)}
                      onChange={e => setIbanConf(e.target.value.replace(/\s/g, ''))}
                      placeholder="ES00 0000 0000 0000 0000 0000"
                      maxLength={40}
                      className={`w-full border rounded-xl px-3 py-2.5 text-sm font-mono focus:outline-none transition-colors ${
                        ibanConf.length >= 10 ? (ibanCoincide && ibanValido ? 'border-green-400 bg-green-50' : 'border-red-400 bg-red-50') : 'border-gray-200 focus:border-red-400'
                      }`}
                    />
                    {ibanConf.length >= 10 && !ibanCoincide && <p className="text-xs text-red-600 mt-0.5">{t.ibanMismatch}</p>}
                  </div>

                  {/* BIC + Titular */}
                  <div className="grid grid-cols-2 gap-3">
                    <div className="space-y-1">
                      <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider">
                        {t.bicLabel} <span className="text-gray-400 font-normal normal-case">{t.bicOptional}</span>
                      </label>
                      <input value={bic} onChange={e => setBic(e.target.value.toUpperCase())} placeholder="BBVAESMMXXX"
                        className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm font-mono focus:outline-none focus:border-red-400" />
                    </div>
                    <div className="space-y-1">
                      <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider">{t.holderLabel}</label>
                      <input value={titular} onChange={e => setTitular(e.target.value)} placeholder={t.holderPh}
                        className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:border-red-400" />
                    </div>
                  </div>
                </>
              )}

              <p className="text-xs text-gray-400 bg-blue-50 rounded-xl px-3 py-2 border border-blue-100">
                {esVisita ? t.chargeInfoVisita : t.chargeInfo(precioConIva)}
              </p>

              {/* Código de comunidad (opcional) */}
              <div className="space-y-1 pt-1">
                <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider">
                  Código de comunidad <span className="font-normal normal-case text-gray-400">(opcional)</span>
                </label>
                <div className="flex gap-2">
                  <input
                    value={codigoCom}
                    onChange={e => { setCodigoCom(e.target.value.toUpperCase()); setComVerif(null); }}
                    placeholder="COM-XXXXX"
                    maxLength={10}
                    className="flex-1 border border-gray-200 rounded-xl px-3 py-2.5 text-sm font-mono focus:outline-none focus:border-red-400"
                  />
                  <button
                    onClick={async () => {
                      const c = codigoCom.trim().toUpperCase();
                      if (!c) return;
                      setVerificandoCom(true); setComVerif(null);
                      try {
                        const r = await fetch(`/.netlify/functions/gestionarComunidades?codigo=${encodeURIComponent(c)}`);
                        const d = await r.json();
                        setComVerif(d);
                      } catch { setComVerif({ valid: false, error: 'Error de conexión' }); }
                      finally { setVerificandoCom(false); }
                    }}
                    disabled={!codigoCom.trim() || verificandoCom}
                    className="px-3 py-2 text-sm font-bold text-white bg-gray-700 hover:bg-gray-800 disabled:opacity-40 rounded-xl flex-shrink-0">
                    {verificandoCom ? '…' : 'Verificar'}
                  </button>
                </div>
                {comVerif?.valid && (
                  <div className="text-xs bg-green-50 border border-green-200 rounded-xl px-3 py-2 text-green-700">
                    <p className="font-bold">✓ {comVerif.nombre}</p>
                    {comVerif.descuentoActivo
                      ? <p className="mt-0.5">Descuento del {comVerif.descuentoPct}% activo para esta comunidad</p>
                      : <p className="mt-0.5">Faltan {comVerif.faltan} contrato{comVerif.faltan !== 1 ? 's' : ''} para activar el descuento del {comVerif.descuentoPct}%</p>}
                  </div>
                )}
                {comVerif && !comVerif.valid && (
                  <p className="text-xs text-red-600 mt-0.5">✕ {comVerif.error || 'Código no válido'}</p>
                )}
              </div>
              <div className="space-y-1 pt-1">
                <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider">
                  Código de socio <span className="font-normal normal-case text-gray-400">(si te lo ha dado quien te recomendó)</span>
                </label>
                <div className="flex gap-2">
                  <input
                    value={codigoSoc}
                    onChange={e => { setCodigoSoc(e.target.value.toUpperCase()); setSocVerif(null); }}
                    placeholder="SOC-XXXXX"
                    maxLength={10}
                    className="flex-1 border border-gray-200 rounded-xl px-3 py-2.5 text-sm font-mono focus:outline-none focus:border-red-400"
                  />
                  <button
                    onClick={async () => {
                      const c = codigoSoc.trim().toUpperCase();
                      if (!c) return;
                      setVerificandoSoc(true); setSocVerif(null);
                      try {
                        const r = await fetch(`/.netlify/functions/gestionarSocios?codigo=${encodeURIComponent(c)}`);
                        const d = await r.json();
                        setSocVerif(d);
                      } catch { setSocVerif({ valid: false, error: 'Error de conexión' }); }
                      finally { setVerificandoSoc(false); }
                    }}
                    disabled={!codigoSoc.trim() || verificandoSoc}
                    className="px-3 py-2 text-sm font-bold text-white bg-gray-700 hover:bg-gray-800 disabled:opacity-40 rounded-xl flex-shrink-0">
                    {verificandoSoc ? '…' : 'Verificar'}
                  </button>
                </div>
                {socVerif?.valid && (
                  <div className="text-xs bg-green-50 border border-green-200 rounded-xl px-3 py-2 text-green-700">
                    <p className="font-bold">✓ {socVerif.nombre}</p>
                    <p className="mt-0.5">Código de socio verificado correctamente</p>
                  </div>
                )}
                {socVerif && !socVerif.valid && (
                  <p className="text-xs text-red-600 mt-0.5">✕ {socVerif.error || 'Código no válido'}</p>
                )}
              </div>
            </div>

            {/* Consentimiento */}
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 px-5 py-5 space-y-3">
              <h3 className="font-bold text-gray-900">{t.consentSection}</h3>
              <label className="flex items-start gap-3 cursor-pointer">
                <input type="checkbox" checked={checkA} onChange={e => setCheckA(e.target.checked)}
                  className="mt-0.5 w-5 h-5 accent-red-600 flex-shrink-0" />
                <span className="text-sm text-gray-700">{t.consentA}</span>
              </label>
              {!esVisita && (
                <label className="flex items-start gap-3 cursor-pointer">
                  <input type="checkbox" checked={checkB} onChange={e => setCheckB(e.target.checked)}
                    className="mt-0.5 w-5 h-5 accent-red-600 flex-shrink-0" />
                  <span className="text-sm text-gray-700">{t.consentB(precioConIva)}</span>
                </label>
              )}
              <label className="flex items-start gap-3 cursor-pointer">
                <input type="checkbox" checked={checkC} onChange={e => setCheckC(e.target.checked)}
                  className="mt-0.5 w-5 h-5 accent-red-600 flex-shrink-0" />
                <span className="text-sm text-gray-500">{t.consentC}</span>
              </label>
            </div>

            {/* Firma */}
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 px-5 py-5 space-y-3">
              <h3 className="font-bold text-gray-900">{t.signSection}</h3>
              <p className="text-sm text-gray-500">{t.signHint}</p>
              <FirmaCanvas onFirma={setFirmaB64} t={t} />
              {firmaB64 && <p className="text-xs text-green-600">{t.signDone}</p>}
            </div>

            {/* Error */}
            {errorMsg && (
              <div className="bg-red-50 border border-red-200 rounded-xl px-4 py-2.5 text-sm text-red-700">{errorMsg}</div>
            )}

            {/* Botón */}
            <button
              onClick={handleFirmar}
              disabled={!puedeEnviar}
              className={`w-full py-4 rounded-2xl font-bold text-base transition-all ${
                puedeEnviar
                  ? 'bg-red-600 hover:bg-red-700 text-white shadow-lg shadow-red-200 active:scale-[0.98]'
                  : 'bg-gray-200 text-gray-400 cursor-not-allowed'
              }`}
            >
              {sending ? (
                <span className="flex items-center justify-center gap-2">
                  <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  {t.submitting}
                </span>
              ) : t.submitBtn}
            </button>

            {!puedeEnviar && !sending && (
              <ul className="text-xs text-gray-400 space-y-0.5 px-1">
                {!dniValido              && <li>• {t.pDni}</li>}
                {!esVisita && !ibanValido             && <li>• {t.pIban}</li>}
                {!esVisita && ibanValido && !ibanCoincide && <li>• {t.pIbanMatch}</li>}
                {!checkA                 && <li>• {t.pConsentA}</li>}
                {!esVisita && !checkB    && <li>• {t.pConsentB}</li>}
                {!firmaB64               && <li>• {t.pSign}</li>}
              </ul>
            )}
          </>
        )}
      </main>
    </div>
  );
}
